import styled, { css } from "styled-components";

export const Wrapper = styled.div<{ $color?: string;}>`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  max-width: 100%;
`;

export const Head = styled.div`
  display: flex;
  width: 100%;
  min-width: max-content;
  max-width: 100%;
`;

export const Col = styled.div<{
  $active?: boolean;
  $type?: "small" | "medium" | "large";
  $isCheckbox?: boolean;
}>`
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--Neutral-200, #e5e5e5);
  color: var(--Neutral-900, #171717);
  padding: 12px;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  font-family: "Inter";
  min-width: 10%;
  width: 100%;
  background-color: ${({ $active }) =>
    $active ? "rgb(244, 249, 251)" : "#f2f5f8"} !important;
  cursor: ${({ $active }) => ($active ? "default" : "default")};

  ${({ $isCheckbox }) =>
    $isCheckbox &&
    css`
      border-left: 6px solid #1c8b7e;
    `}

  ${({ $type }) =>
    $type === "small" &&
    css`
      position: relative;
      min-width: 40px;
      width: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    `}

    ${({ $type }) =>
    $type === "medium" &&
    css`
      width: 100%;
      min-width: 150px;
      max-width: 100%;
      justify-content: center;
    `}

  ${({ $type }) =>
    $type === "large" &&
    css`
      width: 100%;
      min-width: 500px;
      max-width: 100%;

      &:hover {
        .add-category {
          opacity: 1;
          visibility: visible;
        }
      }
    `}
`;

export const WeightContent = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  background: transparent;
  border: none;
  gap: 6px;
`;

export const NameContent = styled.div<{
  $disabled: boolean;
  $active: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  padding: 20px 0px 20px 12px;
  max-width: 600px;

  ${({ $active }) =>
    $active
      ? css`
          &:hover {
            .items-actions {
              opacity: 1;
              visibility: visible;
            }
            button {
              opacity: 1;
              visibility: visible;
            }
          }
        `
      : css`
          .items-actions {
            opacity: 0;
            visibility: hidden;
          }
          button {
            opacity: 0;
            visibility: hidden;
          }
        `}
`;

export const ActionButton = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  opacity: 0;
  visibility: hidden;
`;

export const ProgressContainer = styled.div`
  border: 1px solid #71aaca;
  border-radius: 24px;
  padding: 2px 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;

  span {
    color: #404040;
    font-size: 12px;
    font-weight: 500;
  }
`;

export const NameWrapper = styled.div`
  flex: 1;
  /* min-height: 45px; */
  width: 100%;
  white-space: normal;
  word-break: break-word;
  display: flex;
  align-items: center;
  gap: 20px;

  input {
    height: 100%;
    padding: 13px 12px;
    border-radius: 0;
    margin-right: 12px;
  }

  span {
    display: block;
    cursor: default;
    font-weight: 600;
    font-size: 15px;
    color: #112538;
    font-family: "Inter";
  }
`;

export const Status = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: #404040;
  font-size: 14px;
  font-weight: 400;
  white-space: nowrap;
  padding: 0px 11px;
`;

export const CollapseWrapper = styled.div``;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const AddActionItemBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background: none;
  border: none;
  padding: 0;
  font-family: Inter;
  font-size: 10px;
  font-weight: 600;
  line-height: 20px;
  text-transform: uppercase;
  transition: opacity 0.3s, visibility 0.3s;
  color: #ff9900;
  white-space: nowrap;
  /* opacity: 0; */
  /* visibility: hidden; */
`;

export const Toggle = styled.button<{ $active?: boolean; $isNew?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  width: 100%;
  height: 100%;
  padding: 0;
  transform: rotate(180deg);
  transition: transform 0.3s;

  ${({ $isNew }) =>
    $isNew &&
    css`
      transform: rotate(0deg);
    `}

  ${({ $active }) =>
    $active &&
    css`
      transform: rotate(0deg);
    `}
`;
